export const localization = {
  pt: {
    locale: 'pt-BR',
    header: {
      title:
        'Devido a mudanças na lei de proteção de dados, algumas informações sobre mensagens no WhatsApp estão temporariamente indisponíveis. Estamos avaliando alternativas para disponibilizá-las com segurança.',
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title:
        'Due to changes in data protection regulations, some information about WhatsApp messages is temporarily unavailable. We are exploring alternatives to provide it securely.',
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title:
        'Debido a cambios en las normativas de protección de datos, algunas informaciones sobre mensajes en WhatsApp están temporalmente indisponibles. Estamos evaluando alternativas para ofrecerlas de manera segura.',
    },
  },
};
